import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

const getAllPortfolios = (params) => AxiosClient.get('/portfolio', { ...params })
const createPortfolios = (payload) => AxiosClient.post('/portfolio', { ...payload })
const updatePortfolios = (params, payload) => AxiosClient.put(`/portfolio/${params}`, { ...payload })
const deletePortfolios = (params) => AxiosClient.delete(`/portfolio/${params}`)

export {
    getAllPortfolios,
    createPortfolios,
    updatePortfolios,
    deletePortfolios
}